module.exports = __webpack_public_path__ + "static/media/full_circle.e313b21b.svg";